import { render } from "./CashierOrderSummaryItemComponent.vue?vue&type=template&id=25669de3&scoped=true"
import script from "./CashierOrderSummaryItemComponent.vue?vue&type=script&lang=js"
export * from "./CashierOrderSummaryItemComponent.vue?vue&type=script&lang=js"

import "./CashierOrderSummaryItemComponent.vue?vue&type=style&index=0&id=25669de3&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25669de3"]])

export default __exports__